import { render, staticRenderFns } from "./ImportarClientes.vue?vue&type=template&id=ee182a3a&scoped=true"
import script from "./ImportarClientes.vue?vue&type=script&lang=ts"
export * from "./ImportarClientes.vue?vue&type=script&lang=ts"
import style0 from "./ImportarClientes.vue?vue&type=style&index=0&id=ee182a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee182a3a",
  null
  
)

export default component.exports